import { ITextAreaStyle, TextAlignKinds } from "../../../../base/domain/drawing";
import { IPropertyEditable } from "../../../../base/domain/system/edit";
import { IFontSizeAutoAdjustBehavior, ILineBreakBehavior } from "../../../../documaker/domain/format/objects";
import { IFormatSpecification } from "../IFormatSpecification";
import { ITextDrawableObject } from "../objects";
import {
  ITextStylePropertyEditable,
  IFontSizeAutoAdjustBehaviorPropertyEditable,
  ILineBreakBehaviorPropertyEditable,
} from "../properties";
import { AbstractTextPresentableObjectEditor } from "./AbstractTextPresentableObjectEditor";

export abstract class AbstractTextDrawableObjectEditor<TObject extends ITextDrawableObject> extends AbstractTextPresentableObjectEditor<TObject> implements
ITextStylePropertyEditable,
IFontSizeAutoAdjustBehaviorPropertyEditable,
ILineBreakBehaviorPropertyEditable {
  constructor(source: TObject | AbstractTextDrawableObjectEditor<TObject>, specification?: IFormatSpecification, isNew: boolean = false) {
    super(source, specification, isNew);
    this._id = this.createIdPropertyEditor();
    this._textStyle = this.createTextStylePropertyEditor(s => true);                                    // 既定は編集可に.必要な派生クラスでoverrideして制限する想定.
    this._fontSizeAutoAdjustBehavior = this.createFontSizeAutoAdjustBehaviorPropertyEditor(s => true);  // 既定は編集可に.必要な派生クラスでoverrideして制限する想定.
    this._lineBreakBehavior = this.createLineBreakBehaviorPropertyEditor(s => false);                   // 既定は編集不可に.必要な派生クラスでoverrideして制限する想定.
  }

  protected _textStyle: IPropertyEditable<ITextAreaStyle>;
  protected _fontSizeAutoAdjustBehavior: IPropertyEditable<IFontSizeAutoAdjustBehavior>;
  protected _lineBreakBehavior: IPropertyEditable<ILineBreakBehavior>;

  protected createTextStylePropertyEditor(isWritable?: (s: TObject) => boolean): IPropertyEditable<ITextAreaStyle> {
    return this.createPropertyEditor(
      s => s.textStyle,
      (s, v) => s.textStyle = v,
      isWritable ? isWritable : s => true);
  }

  protected createFontSizeAutoAdjustBehaviorPropertyEditor(isWritable?: (s: TObject) => boolean): IPropertyEditable<IFontSizeAutoAdjustBehavior> {
    return this.createPropertyEditor(
      s => s.fontSizeAutoAdjustBehavior,
      (s, v) => s.fontSizeAutoAdjustBehavior = v,
      isWritable ? isWritable : s => true);
  }

  protected createLineBreakBehaviorPropertyEditor(isWritable?: (s: TObject) => boolean): IPropertyEditable<ILineBreakBehavior> {
    return this.createPropertyEditor(
      s => s.lineBreakBehavior,
      (s, v) => s.lineBreakBehavior = v,
      isWritable ? isWritable : s => true);
  }

  textStyle(): IPropertyEditable<ITextAreaStyle> {
    return this._textStyle;
  }

  getSelectableAlignmentKinds(): TextAlignKinds[] {
    return null;  // 必要な派生クラスでオーバーライドする想定.
  }

  fontSizeAutoAdjustBehavior(): IPropertyEditable<IFontSizeAutoAdjustBehavior> {
    return this._fontSizeAutoAdjustBehavior;
  }

  lineBreakBehavior(): IPropertyEditable<ILineBreakBehavior> {
    return this._lineBreakBehavior;
  }
}
